import { useDispatch } from "react-redux";
import { FetchFunctionResult, useFetch } from "../../../hooks/useFetch";
import { DashboardStats } from "../../../models/stats";
import { StatisticsFilters } from "../shared/filters";
import { showBackendMessage } from "../../../helpers/messagesHelper";
import { getDashboardStats } from "../../../api/stats";
import Messages from "../../../localization/Messages";
import { useIntl } from "react-intl";

export type useFetchDashboardStatsProps = {
    filters: StatisticsFilters;
};

export function useFetchDashboardStats({
    filters,
}: useFetchDashboardStatsProps): FetchFunctionResult<DashboardStats> {
    const dispatch = useDispatch();
    const intl = useIntl();

    const propsJsonString = JSON.stringify(filters);

    const { data, loading, refetch } = useFetch<DashboardStats | null>({
        fetchFn: async () => {
            try {
                const res = await getDashboardStats(JSON.parse(propsJsonString));
                return res.data;
            } catch {
                dispatch(showBackendMessage(intl, "error", "fetching", Messages.statistics));
                return null;
            }
        },
        fetchDeps: [propsJsonString],
    });

    return { data: data ?? undefined, loading, refetch };
}
